import { mailingCommunicationStore } from '@/services/MailingCommunications/store'
import { ValidationError } from '@/services/errors'
import { notifyMessage, notifyError } from '@/services/notify'

export const methods = {
  async reload() {
    this.loading = true

    this.communicationID = this.$route.params.id

    if (this.isDebug == true) console.debug('attachments communicationID=' + this.communicationID)

    this.loading = false
  },

  async saveMessageForFinalize(content, subject) {
    console.debug('finalizeMessage postal...' + content + ', ' + subject + ', ')

    const loadingComponent = this.$buefy.loading.open({
      container: null
    })

    if (content === undefined || !content || content.length === 0) {
      notifyError('The message is required.')
      return
    }

    this.$store.dispatch('communication/composedSmsMessage', {
      smsMessage: content
    })
    this.composedText = content

    this.$store.dispatch('communication/saveSmsSubject', {
      smsSubject: subject
    })

    this.$store.dispatch('communication/saveIsEdit', {
      isEdit: true
    })

    this.composedSubject = subject

    loadingComponent.close()
  },

  async finalizeMessageFromState(showMessage) {
    if (this.hasReadonly === false) {
      const loadingComponent = this.$buefy.loading.open({
        container: null
      })

      try {
        if (
          this.composedText &&
          this.composedText.length > 0 &&
          (this.mailingCommunicationID || this.communicationID)
        ) {
          const params = {
            communicationID: this.mailingCommunicationID
              ? this.mailingCommunicationID
              : this.communicationID,
            supportMailDelivery: false,
            supportEmailDelivery: false,
            supportSMSDelivery: true,
            supportPushDelivery: false,
            isLegalCommunication: false,
            description: this.communicationDescription,
            mailingTypeID: this.mailingTypeID,
            selectedDeliveryOwnerIDs: this.selectedDeliveryOwnerIDs,
            selectedDeliveryOwners: this.selectedDeliveryOwners,
            deliveryDate: this.deliveryDate,
            htmlSmsContent: this.composedText,
            smsSubject: this.composedSubject
          }

          console.debug('mail params=' + JSON.stringify(params))

          await mailingCommunicationStore.dispatch('updateCommunicationMessage', {
            params,
            done: async ({ detail }) => {
              this.$store.dispatch('communication/saveIsEdit', {
                isEdit: true
              })

              if (detail) {
                console.debug('update communication=' + JSON.stringify(detail))

                this.communicationID = detail.communicationID

                this.$store.dispatch('communication/saveIsEdit', {
                  isEdit: true
                })

                if (showMessage !== undefined && showMessage && showMessage === true) {
                  notifyMessage('This SMS message has been saved for sending.')
                }
              }
            }
          })
        }
      } catch (error) {
        console.debug('error=' + error.message)
        loadingComponent.close()
      }

      loadingComponent.close()
    }
  },

  processFinalPreview(content, subject) {
    console.debug('in processFinalPreview...' + content)

    let tempContent = []
    let processedContent = content
    const contentLength = content.length > 17 ? Math.round(content.length / 17) : 0

    console.debug('contentLength=' + contentLength)

    if (contentLength > 0 && content.indexOf('\n') <= -1) {
      processedContent = ''
      for (let i = 0; i < contentLength; i++) {
        let startIndex = processedContent !== undefined ? processedContent.length - i : 0
        let endIndex = 17 * (i + 1)

        tempContent[i] = content.substring(startIndex, endIndex)

        processedContent = processedContent + tempContent[i] + '\n'

        console.debug(
          i +
            '=, processedContent=' +
            processedContent +
            'startIndex=' +
            startIndex +
            'endIndex=' +
            endIndex
        )
      }
    }

    let tempSubject = []
    let processedSubject = subject
    const contentLength2 = subject.length > 17 ? Math.round(subject.length / 17) : 0

    console.debug('contentLength2=' + contentLength2)

    if (contentLength2 > 0 && subject.indexOf('\n') <= -1) {
      processedSubject = ''
      for (let i = 0; i < contentLength2; i++) {
        let startIndex = processedSubject !== undefined ? processedSubject.length - i : 0
        let endIndex = 17 * (i + 1)

        tempSubject[i] = subject.substring(startIndex, endIndex)

        processedSubject = processedSubject + tempSubject[i] + '\n'

        console.debug(
          i +
            '=, processedContent=' +
            processedSubject +
            'startIndex=' +
            startIndex +
            'endIndex=' +
            endIndex
        )
      }
    }

    this.$store.dispatch('communication/composedSmsMessage', {
      smsMessage: content
    })

    this.$store.dispatch('communication/saveSmsSubject', {
      smsSubject: subject
    })

    this.composedText = processedContent
    this.composedSubject = processedSubject
  },

  async finalizeMessage(content, smsSubject) {
    if (this.hasReadonly === false) {
      console.debug('finalizeMessage...')

      const loadingComponent = this.$buefy.loading.open({
        container: null
      })

      if (smsSubject === undefined || !smsSubject) {
        notifyError('The SMS subject is required.')
        loadingComponent.close()
        return
      }

      if (content === undefined || !content) {
        notifyError('The SMS message is required.')
        loadingComponent.close()
        return
      }

      if (content && content.length > 0 && (this.mailingCommunicationID || this.communicationID)) {
        this.$store.dispatch('communication/composedSmsMessage', {
          smsMessage: content
        })
        this.composedText = content

        this.$store.dispatch('communication/saveSmsSubject', {
          smsSubject: smsSubject
        })
        this.composedSubject = smsSubject

        const params = {
          communicationID: this.mailingCommunicationID
            ? this.mailingCommunicationID
            : this.communicationID,
          supportMailDelivery: false,
          supportEmailDelivery: false,
          supportSMSDelivery: true,
          supportPushDelivery: false,
          isLegalCommunication: this.isLegalCommunication,
          description: this.communicationDescription,
          mailFullDuplex: null,
          mailColor: null,
          htmlSmsContent: content,
          smsSubject: smsSubject
        }

        await mailingCommunicationStore.dispatch('updateCommunicationMessage', {
          params,
          done: async ({ detail }) => {
            this.$store.dispatch('communication/saveIsEdit', {
              isEdit: true
            })

            if (detail) {
              console.debug('update communication=' + JSON.stringify(detail))

              this.communicationID = detail.communicationID

              notifyMessage('This message has been saved for sending.')
            }
          }
        })

        loadingComponent.close()
      }
    }
  },

  async onFormSubmit() {
    if (!this.formData || this.formData == undefined) {
      notifyError('There was a problem updating your communication general information.')
      return
    }

    try {
      let validationMessages = ''

      if (!this.formData.mailingTypeID || this.formData.mailingTypeID == 0) {
        validationMessages = '<div>Please select a valid mailing type.</div>'
      }

      if (this.formData.description == null) {
        validationMessages += '<div>Please enter a description.</div>'
      }

      if (validationMessages != '') {
        notifyError(validationMessages)
        return
      }

      if (this.formData.mailingTypeID) {
        this.$store.dispatch('communication/saveMailingTypeID', {
          mailingTypeID: this.formData.mailingTypeID
        })
      }

      if (this.formData.description) {
        this.$store.dispatch('communication/saveDescription', {
          communicationDescription: this.formData.description
        })
      }

      if (this.formData.isLegalCommunication) {
        this.$store.dispatch('communication/saveIsLegalCommunication', {
          isLegalCommunication: this.formData.isLegalCommunication
        })
      }

      this.$store.dispatch('communication/saveIsEdit', {
        isEdit: true
      })

      notifyMessage('The general information is saved for this form entry.')
    } catch (e) {
      // If this is a validation error, get the details for each field
      if (e instanceof ValidationError) {
        this.$refs.form.setErrors(e.fields)
      }

      notifyError('There was a problem saving the communication.' + e)
    }
    this.loading = false
  }
}
